// extracted by mini-css-extract-plugin
module.exports = {"SortFieldColumn":"styles_SortFieldColumn__1cL9T"};